import React from 'react';
import { IconButton, Tooltip, useTheme as useMuiTheme } from '@mui/material';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { useTheme } from '../contexts/ThemeContext';

/**
 * DarkModeToggle component displays a button that toggles between dark and light mode
 * It uses an icon button with a sun/moon icon based on the current theme
 */
export const DarkModeToggle: React.FC = () => {
  const { darkMode, toggleDarkMode } = useTheme();
  const muiTheme = useMuiTheme();

  return (
    <Tooltip title={darkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}>
      <IconButton
        onClick={toggleDarkMode}
        aria-label={darkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
        size="large"
        sx={{
          ml: 1,
          color: 'text.primary',
          transition: 'all 0.3s ease-in-out',
          '&:hover': {
            transform: 'rotate(15deg)',
            color: muiTheme.palette.primary.main,
            bgcolor:
              muiTheme.palette.mode === 'dark'
                ? 'rgba(255, 255, 255, 0.08)'
                : 'rgba(0, 0, 0, 0.08)',
          },
        }}
      >
        {darkMode ? (
          <LightModeIcon sx={{ fontSize: '1.5rem' }} />
        ) : (
          <DarkModeIcon sx={{ fontSize: '1.5rem' }} />
        )}
      </IconButton>
    </Tooltip>
  );
};
